// Mirrors azure-function/src/lib/app.js's SERVICE_PLAN_GROUPS/LICENSE_LABEL —
// keep the two in sync by hand, there's no shared package between the
// Function and this app. A setting gated behind a license the tenant
// doesn't have gets tone 'info' (this is nobody's fault to fix in-app) and
// says exactly which plan is missing, instead of the generic
// "Ikke tilgængeligt endnu" used for our own not-yet-built gaps.
const SERVICE_PLAN_GROUPS = {
  intune: ['INTUNE_A', 'INTUNE_SMBIZ', 'INTUNE_EDU'],
  defenderEndpoint: ['WINDEFATP', 'MDE_LITE'],
  defenderOffice: ['ATP_ENTERPRISE', 'THREAT_INTELLIGENCE'],
  aadPremiumP1: ['AAD_PREMIUM', 'AAD_PREMIUM_P2'],
  aadPremiumP2: ['AAD_PREMIUM_P2'],
};
const LICENSE_LABEL = {
  intune: 'Microsoft Intune',
  defenderEndpoint: 'Microsoft Defender for Endpoint',
  defenderOffice: 'Microsoft Defender for Office 365',
  aadPremiumP1: 'Microsoft Entra ID P1',
  aadPremiumP2: 'Microsoft Entra ID P2',
};

// null means "couldn't tell" (the /subscribedSkus read failed) — callers
// should treat that as "try the real check anyway", never as "not
// licensed", so a transient Graph error never wrongly tells an already-
// licensed customer to go buy something they have.
export function hasLicenseFor(licensedServicePlans, groupKey) {
  if (!Array.isArray(licensedServicePlans)) return null;
  return SERVICE_PLAN_GROUPS[groupKey].some((p) => licensedServicePlans.includes(p));
}

export function licenseGateSetting({ icon, title, description, groupKey, evidenceSchema, checkedAt }) {
  const plan = LICENSE_LABEL[groupKey];
  return {
    icon,
    title,
    description,
    value: `Kræver ${plan}`,
    tone: 'info',
    meaning: description,
    situation: `Denne tenant har ikke en licens, der inkluderer ${plan} — kontakt jeres IT-leverandør, hvis I ønsker at overvåge dette.`,
    recommend: `Tilføj ${plan} til tenantens licenser, hvis dette skal overvåges.`,
    evidence: [
      ['Observed value', `Kræver ${plan}`],
      ['Source', 'Microsoft Graph — /subscribedSkus'],
      ['Collected at', checkedAt],
    ],
  };
}
